import React from 'react'

function UpcomingMovie() {
  return (
    <div>Upcoming Movie</div>
  )
}

export default UpcomingMovie